import { useMemo } from 'react';

import { useFilterOptions } from '$/hooks/data/useFilterOptions';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const useAppliedFilterOptions = () => {
  const appliedFilterOptions = useCollectionStore.useAppliedFilterOptions();
  const { data: filter } = useFilterOptions();

  return useMemo(() => {
    if (!filter) return undefined;

    return appliedFilterOptions.map((appliedFilter) => {
      const found =
        filter?.general.find((f) => f.searchField === appliedFilter.option) ??
        filter?.additional.find((f) => f.searchField === appliedFilter.option);

      return {
        ...found!,
        items: found!.items.filter((item) =>
          Array.isArray(appliedFilter.value)
            ? appliedFilter.value.includes(item.value)
            : item.value === appliedFilter.value,
        ),
      };
    });
  }, [appliedFilterOptions, filter]);
};
